import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import MajorUnitExampleCode from '!!raw-loader!./examples/MajorUnit';
import StyleExampleCode from '!!raw-loader!./examples/Style';
import NoLabelsExampleCode from '!!raw-loader!./examples/NoLabels';
import RangeBandExampleCode from '!!raw-loader!./examples/RangeBand';
import NoValueExampleCode from '!!raw-loader!./examples/NoValue';
import RangeValuesExampleCode from '!!raw-loader!./examples/RangeValues';
import MinorTicksExampleCode from '!!raw-loader!./examples/MinorTicks';
import MajorTicksExampleCode from '!!raw-loader!./examples/MajorTicks';
import StartAngleExampleCode from '!!raw-loader!./examples/StartAngle';
import ArcAngle360ExampleCode from '!!raw-loader!./examples/ArcAngle360';
import PercentageRangeExampleCode from '!!raw-loader!./examples/PercentageRange';
import PercentageValueExampleCode from '!!raw-loader!./examples/PercentageValue';
import BackgroundColorExampleCode from '!!raw-loader!./examples/BackgroundColor';
import GaugeColorsExampleCode from '!!raw-loader!./examples/GaugeColors';

import BasicExample from './examples/Basic';
import MajorUnitExample from './examples/MajorUnit';
import StyleExample from './examples/Style';
import NoLabelsExample from './examples/NoLabels';
import RangeBandExample from './examples/RangeBand';
import NoValueExample from './examples/NoValue';
import RangeValuesExample from './examples/RangeValues';
import MinorTicksExample from './examples/MinorTicks';
import MajorTicksExample from './examples/MajorTicks';
import StartAngleExample from './examples/StartAngle';
import ArcAngle360Example from './examples/ArcAngle360';
import PercentageRangeExample from './examples/PercentageRange';
import PercentageValueExample from './examples/PercentageValue';
import BackgroundColorExample from './examples/BackgroundColor';
import GaugeColorsExample from './examples/GaugeColors';

import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="RadialGauge"
        examplesSection={[
            <DocExample
                title="Basic Radial Gauge"
                key="basic"
                description="Radial Gauge takes 100% width and 250px height by default."
                code={BasicExampleCode}
                example={BasicExample}
            />,
            <DocExample
                title="Мajor Unit is 30"
                key="major_unit"
                description="Specifies, in pixels, the spacing of major tick marks."
                code={MajorUnitExampleCode}
                example={MajorUnitExample}
            />,
            <DocExample
                title="Minimal Style"
                key="minimal_style"
                description="Minimal style of the gauge. 'shiny' by default."
                code={StyleExampleCode}
                example={StyleExample}
            />,
            <DocExample
                title="No Labels"
                key="no_labels"
                description="Gauge display no labels. Defaults to true."
                code={NoLabelsExampleCode}
                example={NoLabelsExample}
            />,
            <DocExample
                title="No Range Band"
                key="No_range_band"
                description="Gauge doesn't show the color ranges as a band at the top of the radial gauge."
                code={RangeBandExampleCode}
                example={RangeBandExample}
            />,
            <DocExample
                title="No Value"
                key="no_value"
                decription="Gauge doesn't displays its value. Defaults to true."
                code={NoValueExampleCode}
                example={NoValueExample}
            />,
            <DocExample
                title="Range Values [0, 200, 500, 800, 900]"
                key="range_values"
                description="Range values [0, 200, 500, 800, 900] indicates that the gauge starts at zero, ends at 900, and has four subranges that are each identified by another color."
                code={RangeValuesExampleCode}
                example={RangeValuesExample}
            />,
            <DocExample
                title="Show Minor Ticks"
                key="show_minor_ticks"
                description="Gauge displays minor tick marks. Defaults to false."
                code={MinorTicksExampleCode}
                example={MinorTicksExample}
            />,

            <DocExample
                title="No Major Ticks"
                key="major_ticks"
                description="Gauge doesn't display major tick marks. Defaults to true."
                code={MajorTicksExampleCode}
                example={MajorTicksExample}
            />,
            <DocExample
                title="Start Angle at 90"
                key="start_angle"
                description="The angle of range arc starts at 90 degrees. Defaults to 45 degrees."
                code={StartAngleExampleCode}
                example={StartAngleExample}
            />,
            <DocExample
                title="Range Arc Angle is 360"
                key="range_arc_angle"
                description="The length of the range arc is 360 degrees. Positive values are clockwise. Negative values are counterclockwise. Defaults to 270."
                code={ArcAngle360ExampleCode}
                example={ArcAngle360Example}
            />,
            <DocExample
                title="Percentage Range"
                key="percentage_range"
                description="Gauge displays range values as percentages. Defaults to false."
                code={PercentageRangeExampleCode}
                example={PercentageRangeExample}
            />,
            <DocExample
                title="Percentage Value"
                key="percentage_value"
                description="Gauge displays values as percentages. Defaults to false."
                code={PercentageValueExampleCode}
                example={PercentageValueExample}
            />,
            <DocExample
                title="Background Color is Blue"
                key="background_color"
                description="The HEX color code for chart background color is blue."
                code={BackgroundColorExampleCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Gauge Colors are Red Yellow and Green"
                key="gauge_colors"
                description="An array of hexadecimal color values from which the range band colors are generated. Colors display in the order indicated in the array."
                code={GaugeColorsExampleCode}
                example={GaugeColorsExample}
            />,
        ]}
        optionSection={<OptionsDoc options={optionsSchema} />}
    />
);
